import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { YetiSocket } from '../yeti-socket';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Injectable({
	providedIn: 'root'
})
export class UserUnreadMessagesUpdatedService {

	private echo: Echo<any>;
	private subject: Subject<IResponse>;
	private listenEvent: string;
	private channelEvent: string;

	constructor() {
		this.echo = YetiSocket.connect();
		this.subject = new Subject<IResponse>();
	}

	/**
	 * Create channel.
	 * @param userId
	 * @returns 
	 */
	public createChannel(userId: number): void {
		if (!userId) {
			return;
		}

		const channelEvent = environment.socketChannel;
		const listenEvent = StringHelper.sprintf('.user_unread_messages_updated_%d', userId);

		if (
			this.channelEvent == channelEvent &&
			this.listenEvent == listenEvent
		) {
			return;
		}

		// Keep only one instance. Remove the old ones to start a new channel and listener.
		if (this.channelEvent) {
			this.echo
				.channel(this.channelEvent)
				.stopListening(this.listenEvent);
			this.echo
				.leaveChannel(this.channelEvent);
		}

		this.channelEvent = channelEvent;
		this.listenEvent = listenEvent;
		// Create a instance one.
		this.echo
			.channel(this.channelEvent)
			.listen(this.listenEvent, (data: IResponse) => {
				this.subject.next(data);
			});
	}

	public listener(): Observable<IResponse> {
		return this.subject?.asObservable();
	}

	public local(unread_messages?: number) {
		this.subject.next({ unread_messages });
	}
}

interface IResponse {
	unread_messages?: number;
}
